<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gOV2Bz/tc-custom/9781576337547.jpg?1718282660680" alt="This image is the cover for the book PRAXIS II Biology Test Prep Review--Exambusters Flash Cards, Exambusters PRAXIS 2"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">PRAXIS II Biology Test Prep Review--Exambusters Flash Cards, Exambusters PRAXIS 2
      </h1>
      <p class="bookDescription body article font2">
        <p>"PRAXIS BIOLOGY Study Guide" 450 questions and answers (ILLUSTRATED). Essential definitions and concepts. Topics: Cells, Biochemistry and Energy, Evolution and Classification, Kingdoms: Bacteria, Fungi, Protista; Kingdom: Plantae, Kingdom: Animalia, Human Locomotion, Human Circulation and Immunology, Human Respiration and Excretion, Human Digestion, Human Nervous System, Human Endocrinology, Reproduction and Development, Genetics, Ecology [==================] ADDITIONAL GENERAL SCIENCES WORKBOOKS: "PRAXIS 2 Prep Flashcard Workbook: CHEMISTRY" 700 questions and answers. Essential definitions, formulas, concepts, and sample problems. Topics: Introduction, Matter, Atoms, Formulas, Moles, Reactions, Elements, Periodic Table, Electrons, Chemical Bonds, Heat, Gases, Phase Changes, Solutions, Reaction Rates, Equilibrium, Acids and Bases, Oxidation and Reduction, Introduction to Organic Chemistry, Radioactivity _______________ "PRAXIS 2 Prep Flashcard Workbook: PHYSICS" 600 questions and answers. Essential definitions, formulas, concepts, and sample problems. Topics: Measurement, Motion and Forces, Work and Energy, Heat and Gases, Atoms, Fluids, Sound, Light and Optics, DC Circuits, Magnetism, AC Circuits [==================] "EXAMBUSTERS PRAXIS Prep Workbooks" provide comprehensive PRAXIS review--one fact at a time--to prepare students to take practice PRAXIS tests. Each PRAXIS study guide focuses on fundamental concepts and definitions--a basic overview to begin studying for the PRAXIS exam. Up to 600 questions and answers, each volume in the PRAXIS series is a quick and easy, focused read. Reviewing PRAXIS flash cards is the first step toward more confident PRAXIS preparation and ultimately, higher PRAXIS exam scores!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        PRAXIS II Exambusters
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Cram Now!
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4874383a